import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { IAddressBookData, IAddressBookDataPage } from '@models/addressbook/IAddressBookData';
import { IPersonCard, IGroupMembersPage } from '@models/addressbook/IPersonCard';

export class AddressBookService {
    static async fetchTreeData(
        cache: string,
        node: string,
        items: number[],
        loadOptions: any,
    ): Promise<AxiosResponse<IAddressBookDataPage, any>> {
        return $api.get<IAddressBookDataPage>(
            `/addressbook/tree/data/get${loadOptions}&cache=${cache}&node=${node ?? ''}&items=${
                items?.length > 0 ? items.join(',') : ''
            }`,
        );
    }

    static async fetchAbookItemsByKeys(keys: string[]): Promise<AxiosResponse<IAddressBookData[], any>> {
        return $api.post<IAddressBookData[]>(`/addressbook/dataByKeys`, { keys: keys });
    }

    /** Карточка пользователя (ФИО, должность, контакты) для hover-превью. */
    static async fetchPersonCard(key: string): Promise<AxiosResponse<IPersonCard, any>> {
        return $api.get<IPersonCard>(`/addressbook/personCard/${key}`);
    }

    /** Участники группы порциями + поиск по имени (для модалки «Все участники»). */
    static async fetchGroupMembers(
        groupKey: string,
        skip: number,
        take: number,
        search?: string,
    ): Promise<AxiosResponse<IGroupMembersPage, any>> {
        return $api.get<IGroupMembersPage>(`/addressbook/group/${groupKey}/members`, {
            params: { skip, take, ...(search ? { search } : {}) },
        });
    }

    static async fetchListData(
        cache: string,
        items: number[],
        loadOptions: any,
    ): Promise<AxiosResponse<IAddressBookDataPage, any>> {
        return $api.get<IAddressBookDataPage>(
            `/addressbook/list/data/get${loadOptions}&cache=${cache}&items=${items?.length > 0 ? items.join(',') : ''}`,
        );
    }

    /** Порция вкладки для выпадающего списка; `keys` — только эти элементы, если они проходят условия вкладки. */
    static async fetchListPage(
        cache: string,
        loadOptions: string,
        formValues: string,
        keys?: string[],
    ): Promise<AxiosResponse<IAddressBookDataPage, any>> {
        return $api.get<IAddressBookDataPage>(`/addressbook/list/data/get?${loadOptions}`, {
            params: { cache, formValues, ...(keys?.length ? { keys: keys.join(',') } : {}) },
        });
    }

    static async fetchExternalSearch(
        searchApiUrl: string,
        searchText: string,
        loadOptions: any,
        signal?: AbortSignal,
    ): Promise<AxiosResponse<IAddressBookDataPage, any>> {
        // Поисковая фраза — сегментом пути: в журналы поддержки — без неё.
        return $api.get<IAddressBookDataPage>(`${searchApiUrl}${searchText}/get${loadOptions}`, {
            signal,
            supportLogUrl: `${searchApiUrl}…/get`,
        });
    }

    static async saveExternalSearch(saveApiUrl: string, data: IAddressBookData): Promise<AxiosResponse<any>> {
        return $api.post<any>(`${saveApiUrl}`, data);
    }

    static async fetchListSelectedKeys(cache: string, items: number[]): Promise<AxiosResponse<number[], any>> {
        return $api.get<number[]>('/addressbook/list/selectedKeys/get', {
            params: {
                cache: cache,
                items: items?.length > 0 ? items.join(',') : '',
            },
        });
    }
}
